<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-证书-添加
    -->
    <el-dialog
    title="添加证书"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加证书</div>
      <el-form-item label="证书名称" prop="name"><el-input v-model="form.name" placeholder="请输入证书名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="选择等级">
          <el-select v-model="form.grade_id" placeholder="请选择">
    
            <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
          </el-select>
          
        </el-form-item>

      <!--基本信息-->
    <div class="common-form">海报设置</div>
    <div class="poster-box d-s-s" v-loading="loading" style="overflow-x: scroll;width: 1200px;">
      
      <div class="left-box" 
      :style="'width:'+form.setting.backdrop.width+'px;'+
      'height:'+form.setting.backdrop.height+'px;'">
        <div v-if="form.setting.backdrop"  class="img"  style="border:1px solid blue;">
          <img  v-img-url="form.setting.backdrop.src" />
        </div>
        <div class="userinfo" style="border:1px solid red;">

          <div
            v-for="(item,index) in form.setting.textArr" :key="index"
            class="name pa"
             v-drag="{type:'name',obj:curObj}"
             @mousedown="handleDragClick(index)"
            :style="'font-size:' + item.fontSize + 'px;color:' 
            + item.color + ';top:' + item.top + 'px;left:' + item.left + 'px;'"
         
          >
            {{item.text}}
          </div>
         
        </div>
      </div>

      <div class="right-box"  style="margin: 10px; padding-right: 20px;">

        <el-form size="small" ref="form" :model="form" style="float: left">
          <el-form-item label="海报背景图">
            <el-button type="primary" @click="openUpload(1)">上传图片</el-button>
          </el-form-item>
          <el-form-item label="背景宽度(不能超过800 不能低于375)" prop="fontSize" >
                  <el-input  v-model="form.setting.backdrop.width" min="12" type="number" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="背景高度(不能超过800 不能低于640)" prop="fontSize" >
                  <el-input v-model="form.setting.backdrop.height" min="12" type="number" class="max-w460"></el-input>
              </el-form-item>
              <div style="display: flex;">
                <div @click="shu">竖版通用尺寸</div>
                <div @click="heng" style="margin-left: 10px;">横板通用尺寸</div> 
              </div>
               

          <div style="overflow-x: scroll;height: 400px;padding-right: 30px;">
            <div v-for="(item,index) in form.setting.textArr" :key="index" 
            style="margin-top: 20px;background: #f7f7f7;padding: 10px;">
              <el-form-item label="文字" prop="fontSize" >
                  <el-input v-model="item.text" min="22" type="text" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="字体大小" prop="fontSize" >
                  <el-input v-model="item.fontSize" min="12" type="number" class="max-w460"></el-input>
              </el-form-item>
           
              <el-form-item label="字体左" prop="fontSize" >
                  <el-input v-model="item.left" min="12" type="number" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="字体上" prop="fontSize" >
                  <el-input v-model="item.top" min="12" type="number" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="字体颜色">
                <div class="d-s-c">
                  <el-color-picker v-model="item.color"></el-color-picker>
                  <el-button type="button" style="margin-left: 10px;" 
                  @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">重置</el-button>
                </div>
              </el-form-item> 
              <el-form-item label="字体初始值(手机端会自动获取，后台不会)">
                <el-radio-group v-model="item.original" >
                  <el-radio label="no">不选择</el-radio>
                  <el-radio label="user_nickname">用户昵称</el-radio>
                  <el-radio label="user_mobile">用户手机号</el-radio>
                  <el-radio label="user_name">用户姓名</el-radio>
       
                </el-radio-group>
              </el-form-item> 

              <el-form-item label="字体复位">
                <el-button  style="float: right;" @click="reset(index)" :loading="loading">重置位置</el-button>
              </el-form-item> 

              <el-form-item label="操作">
                <el-button  style="float: right;" @click="del(index)" :loading="loading">删除</el-button>
              </el-form-item> 
            </div>

          </div>
          
        
          <el-button type="primary" style="float: right;margin-right: 10px;" @click="addText" :loading="loading">添加文字</el-button>
          <!--提交-->
       
        </el-form>
      </div>
      
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    
      <!--提交-->
    
      <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      
      </div>
     
    </el-form>
  </div>
</el-dialog>
  
</template>

<script>
import CertApi from '@/api/cert.js';
import Upload from '@/components/file/Upload';
export default {
  components: {
    Upload,
  },
  data() {
    return {
  
      /*form表单数据*/
      form: {
        name: '',
        code: 'cert',
        grade_id:"",
        setting:{
          textArr:[{
            fontSize: 20,
            color:'',
            left:20,
            top:20,
            text:"文字",
            original:"user_nickname",//user_nickname  user_mobile user_name no 不选择
          }],
  

          backdrop: {
            src: '',
            width:375,
            height:640
          }
        }
        
        
      },
      /*是否上传图片*/
      isupload: false,
      /*当前对象*/
      curObj:this,
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入证书名称', trigger: 'blur' }],
      },
      dialogVisible:false,

      drag_index:0,//选中的组件
      gradeList:[]
    };
  },
  created() {
     /*获取数据*/

    this.dialogVisible = this.open_add;
   this.gradeListVal();
  },
  props: ["open_add"],
  directives: {
    /*拖动指令*/
    drag: {
      inserted: function(el, binding) {
        let self = this;
        el.onmousedown = function(event) {
          event = event || window.event;
          let diffX = event.clientX - el.offsetLeft;
          let diffY = event.clientY - el.offsetTop;

          /*鼠标移动*/
          document.onmousemove = function(event) {
            event = event || window.event;
            let moveX = event.clientX - diffX;
            let moveY = event.clientY - diffY;
            binding.value.obj.dragDiv(moveX,moveY,binding.value.type);
          };

          /*鼠标弹起*/
          document.onmouseup = function(event) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  methods: {
    gradeListVal(){
      var self = this;
      CertApi.getGrade({}, true).then(data => {
              console.log(data)
              self.gradeList =    data.data
      }).catch(error => {
                   
      });
    },
    shu(){
      this.form.setting.backdrop.width = 375
      this.form.setting.backdrop.height = 640
    },
    heng(){
      this.form.setting.backdrop.width = 800
      this.form.setting.backdrop.height = 640
    },
    handleDragClick(index){//当前选中的组件
      this.drag_index = index;
    },
    reset(){//重置位置
      this.form.setting.textArr[this.drag_index].left  = 20;
      this.form.setting.textArr[this.drag_index].top  = 20;
    },
    del(index){
      this.form.setting.textArr =  this.form.setting.textArr.filter((item,ind)=>{
          return ind != index
        })
      
     
    },
    addText(){//添加文字
      this.form.setting.textArr.push({
        fontSize: 20,
          color:'',
          left:20,
          top:20,
          text:"文字",
          original:"no"
      });
    },
    gen(){
      let self = this;
      if(!self.judge(self)){
        return false
      }
      var xform = self.form;
      xform.setting = JSON.stringify(xform.setting)
      CertApi.edit(xform, true)
            .then(data => {
              CertApi.gen({
                cert_id: self.cert_id
              }, true)
                    .then(data => {
                      self.form.setting = JSON.parse(self.form.setting);
            
                      window.open(data.data.qrcode);
                    })
                    .catch(error => {
                   
                    });
              
            })
            .catch(error => {
            
            });
      
    },


     /*关闭弹窗*/
     dialogFormVisible() {
      this.$emit("close", { openDialog: false});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
    
      if(!self.judge(self)){
        return false
      }
      form.setting = JSON.stringify(form.setting)
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CertApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
             
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false});
    },


    /*拖动赋值*/
    dragDiv(x, y,type) {
      if(x<0){
        x=0;
      }
      if(y<0){
        y=0;
      }
       if(type=='name'){
        this.form.setting.textArr[this.drag_index].left=x;
        this.form.setting.textArr[this.drag_index].top=y;
      }

    },

    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null) {
        if (this.type == 1) {
          this.form.setting.backdrop.src = e[0].file_path;
        }
       
      }
      this.isupload = false;
    },
    judge(self){
      if (typeof self.form.setting === "string") {
        self.form.setting = JSON.parse(self.form.setting);
      } 
    
      
      console.log(self.form.setting.backdrop);
      if(parseFloat(self.form.setting.backdrop.width)>800 || parseFloat(self.form.setting.backdrop.width)<375){
            self.$message({
              message: "图片宽度不能高于800，不能低于375",
              type: 'error'
            });  
            return false;
      }
      if(parseFloat(self.form.setting.backdrop.height)>800 || parseFloat(self.form.setting.backdrop.height)<640){
            self.$message({
              message: "图片高度不能高于800，不能低于640",
              type: 'error'
            });  
            return false;
      }

      return true;
    }

  }
};
</script>

<style scoped="scoped">
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}




.poster-box .left-box {
  position: relative;
 

  overflow: hidden;
  margin: 0 30px;
  border: 1px solid #cccccc;
  border-radius: 18px;
}
.poster-box .left-box .userinfo {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  top: 0px;
  left: 0px;
}
.poster-box .left-box .userinfo .photo {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background: #ffffff;
  cursor: pointer;
}
.poster-box .left-box .userinfo .photo .svg-icon {
  width: 80%;
  height: 80%;
  font-size: 60px;
  color: #3a8ee6;
}
.poster-box .left-box .userinfo .photo img {
  width: 100%;
  height: 100%;
}
.poster-box .left-box img {
  width: 100%;
  height: 100%;
  position: absolute;
  top:0px;
  left: 0px;
}
.poster-box .left-box .userinfo .name {
  min-height: 30px;
  line-height: 100%;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.poster-box .left-box .userinfo .code {
  cursor: pointer;
  overflow: hidden;
}
.poster-box .left-box .userinfo .code .img {
  width: 100%;
  height: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/plus/cert/part/add.vue